import React, { useEffect } from 'react';
import SocialMedias from './SocialMedias';
import FooterLinks from './FooterLinks';
import StandardFooter from './StandardFooter';
import { useResto } from '../../contexts/RestoContext';
import config from '../../config/config';

const Footer = () => {

  const { restoData } = useResto();
  useEffect(() => {
    if (restoData.hasLogo && !restoData.hasFooterLogo) {
      const footer = document.querySelector('.footer');
      const imageUrl = `${config.documentsUrl}logos/logo_transparent.png`;
      footer.style.backgroundImage = `url(${imageUrl})`;
    }

  }, [restoData.hasLogo]);

  return (
    <footer className='footer'>
      <SocialMedias />
      <FooterLinks />
      <StandardFooter />
    </footer>
  );
}

export default Footer;